var _defs, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416.81 493.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.02,263.01c4.4-5.23,13.33-9.18,26.79-11.87v-2.92c-35.47,1.46-71.05,1.46-106.77,0v2.92c13.72,2.68,22.77,6.57,27.18,11.68,4.4,5.11,7.12,15.09,8.15,29.94.78,20.21,1.17,43.69,1.17,70.47h-129.29c0-15.64.15-29.63.45-41.99l-34.23,38.93c0,2.21,0,4.44,0,6.71,0,33.59-.52,60.97-1.55,82.15-.52,14.6-3.11,24.52-7.77,29.76-4.66,5.24-13.72,9.19-27.18,11.87v2.92c35.46-1.46,71.05-1.46,106.77,0v-2.92c-13.72-2.92-22.78-6.87-27.18-11.87-4.4-4.99-6.99-14.91-7.77-29.76-1.04-20.45-1.55-47.1-1.55-79.96h129.29c0,29.45-.39,56.11-1.17,79.96-.78,14.6-3.49,24.52-8.15,29.76-4.66,5.24-13.72,9.19-27.18,11.87v2.92c35.72-1.46,71.31-1.46,106.77,0v-2.92c-13.72-2.92-22.78-6.87-27.18-11.87-4.41-4.99-6.99-14.91-7.77-29.76-1.04-21.18-1.55-48.56-1.55-82.15,0-30.67.52-55.37,1.55-74.12,1.03-14.6,3.75-24.52,8.15-29.76Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.91,
    y: 95.08,
    width: 9.01,
    height: 412.13,
    transform: "translate(198.8 -48.29) rotate(33.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.43,252.48c-3.63-7.93-2.62-18.63,3.03-32.09l18.97-48.03h98.89c3.95,10.26,10.6,28.77,19.94,55.48l24.77-36.74-43.9-105.12c-11.3-26.64-22.34-55.3-33.1-85.98h-5.65L42.79,218.78c-5.65,14-11.57,24.96-17.76,32.9-6.19,7.94-14.53,14.06-25.03,18.37v3.23c24.75-1.07,49.91-1.07,75.48,0v-3.23c-15.07-3.77-24.42-9.62-28.05-17.56ZM117.06,52.88h.81c19.91,43.87,35.92,81.68,48.03,113.42h-94.05l45.21-113.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e374f90351a0b1e11f17ca28e4ebece.svg";
export { ForwardRef as ReactComponent };